import { useEffect } from 'react';

const ChatbaseScript = () => {
  useEffect(() => {
    // Create and inject the script
    const script = document.createElement('script');
    script.innerHTML = `
      (function(){if(!window.chatbase||window.chatbase("getState")!=="initialized"){window.chatbase=(...arguments)=>{if(!window.chatbase.q){window.chatbase.q=[]}window.chatbase.q.push(arguments)};window.chatbase=new Proxy(window.chatbase,{get(target,prop){if(prop==="q"){return target.q}return(...args)=>target(prop,...args)}})}const onLoad=function(){const script=document.createElement("script");script.src="https://www.chatbase.co/embed.min.js";script.id="OWpidYbShWtiKc_FR3Fan";script.domain="www.chatbase.co";document.body.appendChild(script)};if(document.readyState==="complete"){onLoad()}else{window.addEventListener("load",onLoad)}})();
    `;
    document.body.appendChild(script);

    // Cleanup function
    return () => {
      // Remove the script when component unmounts
      const scripts = document.getElementsByTagName('script');
      for (let i = 0; i < scripts.length; i++) {
        if (scripts[i].innerHTML.includes('chatbase')) {
          scripts[i].remove();
        }
      }
      // Also remove the chatbase embed script if it exists
      const embedScript = document.getElementById('OWpidYbShWtiKc_FR3Fan');
      if (embedScript) {
        embedScript.remove();
      }
    };
  }, []);

  return null;
};

export default ChatbaseScript; 